import React from 'react';
import styled from 'styled-components';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import breakpoints from '@rsc/ui-components/breakpoints';
import { styles } from '@components/utils';
import ReactPaginate from 'react-paginate';

const PaginationWrapper = styled.div`
  ul {
    padding: 0;
    margin: 1rem 0 2.625rem;
    display: flex;
    justify-content: space-evenly;
    list-style: none;
    padding-top: 2rem;
    padding-bottom: 2rem;

    li {
      display: none;
      a {
        font-size: ${styles.fontSize.base};
        font-weight: ${styles.fontWeight.extraLight};
        padding: 0.625rem 1rem;
        display: block;
        color: black;
        cursor: pointer;
      }
      &.previous,
      &.next {
        display: block;
        text-transform: none;
        a {
          color: white;
          background-color: ${styles.colors.blue[700]};
          display: block;
        }
      }
      &.disabled {
        display: none;
      }
    }
    @media (min-width: ${breakpoints.md}) {
      ul {
        justify-content: center;
      }
      li {
        padding: 0px 0.625rem;
        display: block;

        a {
          &.selected,
          &:hover {
            color: white;
            background-color: ${styles.colors.blue[700]};
          }
        }
      }
    }
    @media (min-width: ${breakpoints.lg}) {
      li a {
        font-size: ${styles.fontSize.lg};
        font-weight: ${styles.fontWeight.extraLight};
        padding: 0.5rem 1rem;
      }
    }
  }
`;

const MobilePaginationItem = styled.div`
  display: block;
  margin: 1.625rem 0 0 0;
  text-align: center;
  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

const Pagination = ({ numPages, currentPage, baseUrl }) => (
  <PaginationWrapper>
    <MobilePaginationItem>
      Page {currentPage}/{numPages}
    </MobilePaginationItem>
    <ReactPaginate
      pageCount={numPages}
      initialPage={currentPage - 1}
      pageRangeDisplayed={4}
      marginPagesDisplayed={1}
      activeLinkClassName="selected"
      onPageChange={page => {
        navigate(
          `/${baseUrl}/${page.selected + 1 === 1 ? '' : page.selected + 1}`
        );
      }}
      disableInitialCallback
    />
  </PaginationWrapper>
);
Pagination.propTypes = {
  numPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  baseUrl: PropTypes.string.isRequired,
};

export default Pagination;
